import { selectors as reduxSelectors } from './setup-redux.js';

// TODO: remove manually injection of selectors that are not available in the redux module.
const selectors = {
  ...reduxSelectors,
  assets: {
    ...reduxSelectors.assets,
    moneroIsOutOfDate: () => false,
    algoMustOptIn: () => false,
  },
} as typeof reduxSelectors;

export default selectors;
